import { loginByPassword, longinBySms, getUserInfo } from "@/api/user";
import router from "@/routers";
import store from '@/store'

const state = () => ({
    userInfo: undefined
})

// getters
const getters = {
    getUserInfo(state) {
        if (state.userInfo === undefined) {
            store.dispatch('user/updateUser')
        }
        return state.userInfo
    }
}

// actions
const actions = {
    updateUser({commit}, ) {
        const token = window.localStorage.getItem("TOKEN")
        if (token) {
            getUserInfo().then(res => {
                commit('setUserInfo', res)
            })
        }

    },
    loginByPassword({commit}, data) {
        console.log('账号密码登录', data)
        loginByPassword(data).then(res => {
            console.log(res)
            const {token} = res
            window.localStorage.setItem('TOKEN', token)
            commit('setUserInfo', res)
            router.replace({
                path: '/'
            })
        })
    },
    loginBySms({commit}, data) {
        console.log('验证码登录注册', data)
        longinBySms(data).then(res => {
            console.log(res)
            const {token} = res
            window.localStorage.setItem('TOKEN', token)
            commit('setUserInfo', res)
            router.replace({
                path: '/'
            })
        })
    },
    logout({ commit }) {
        window.localStorage.setItem('TOKEN', '')
        commit('setUserInfo', undefined)
        router.replace({
            path: '/'
        })
    },
}

// mutations
const mutations = {
    setUserInfo(state, userInfo) {
        state.userInfo = userInfo
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
